import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

// ===================== Pages Components ======================
import Hello from "./components/Hello";
import Submit from "./components/Submit";
import ArticlePage from "./components/ArticlePage";
import EditPage from "./components/EditPage";
import LexicalUnit from "./components/LexicalUnit";
import Login from "./components/Login";
import Register from "./components/Register";
import ReviewPage from "./components/ReviewPage";
import SubmissionsList from "./components/SubmissionsList";

// ==================== Router registration ====================

const router = new Router({
  mode: "hash",
  routes: [
    { path: "/", component: Hello },
    { path: "/submit", component: Submit },
    { path: "/login", component: Login },
    { path: "/register", component: Register },
    { path: "/article/:id", component: ArticlePage },
    { path: "/lexical/:id", component: LexicalUnit },
    {
      path: "/submissions",
      component: SubmissionsList,
      meta: { requiresAuth: true },
    },
    {
      path: "/article/:id/edit",
      component: EditPage,
      meta: { requiresAuth: true },
    },
    {
      path: "/article/:id/review",
      component: ReviewPage,
      meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js